<template>
  <HeaderVue />
  <div class="page-content">
    <div
      class="chat-wrapper d-lg-flex gap-2 mt-n4 p-2 overflow-hidden msg-page"
    >
      <ProgressTiket :autono="autono" v-on:show-class="updateClass" />
      <div
        :class="
          !showChat
            ? falseChat
            : 'user-chat w-100 overflow-hidden user-chat-show'
        "
      >
        <div
          class="chat-content d-lg-flex rounded-3 shadow-sm border bg-white msg-chat-shell"
        >
          <div class="w-100 overflow-hidden d-flex flex-column">
            <div
              class="position-relative flex-grow-1 d-flex flex-column msg-min-h-0"
            >
              <div
                class="p-3 user-chat-topbar border-bottom msg-topbar flex-shrink-0"
              >
                <div class="row align-items-center g-2">
                  <div class="col">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 d-block d-lg-none me-2">
                        <button
                          type="button"
                          class="btn btn-light btn-sm rounded-circle msg-back-btn"
                          aria-label="Kembali ke daftar"
                          @click.prevent="removeClass"
                        >
                          <i
                            class="ri-arrow-left-s-line fs-5"
                            aria-hidden="true"
                          ></i>
                        </button>
                      </div>
                      <div class="flex-grow-1 overflow-hidden">
                        <div v-if="level_name === 'ADMINISTRATOR'">
                          <h5 class="text-truncate mb-0 fw-semibold fs-16">
                            <span class="text-reset">Histori chat</span>
                          </h5>
                          <p class="text-muted small mb-0 mt-1">
                            Hanya melihat riwayat percakapan tiket ini.
                          </p>
                        </div>
                        <div class="d-flex align-items-center gap-3" v-else>
                          <div
                            class="flex-shrink-0 chat-user-img online user-own-img align-self-center position-relative"
                          >
                            <img
                              src="@/assets/usr.png"
                              class="rounded-circle avatar-sm border border-2 border-white shadow-sm"
                              alt=""
                              width="40"
                              height="40"
                            />
                            <span class="user-status" aria-hidden="true"></span>
                          </div>
                          <div class="flex-grow-1 overflow-hidden msg-min-w-0">
                            <h5 class="text-truncate mb-0 fw-semibold fs-16">
                              Customer support
                            </h5>
                            <p class="text-muted small mb-0 text-truncate">
                              Kami siap membantu keluhan Anda.
                            </p>
                            <div v-if="status == 'closed'" class="mt-2">
                              <span
                                class="badge rounded-pill bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25 msg-closed-badge"
                              >
                                <i
                                  class="ri-lock-line me-1"
                                  aria-hidden="true"
                                ></i>
                                Tiket ditutup — chat hanya dibaca
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="position-relative flex-grow-1 msg-min-h-0 d-flex flex-column"
                id="users-chat"
              >
                <div
                  class="chat-conversation p-3 p-lg-4 flex-grow-1 msg-conversation"
                  id="chat-conversation"
                  data-simplebar
                >
                  <div
                    v-if="!state.messages.length"
                    class="msg-empty text-center py-5 px-3"
                    role="status"
                  >
                    <div
                      class="msg-empty-icon rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                    >
                      <i
                        class="ri-chat-smile-2-line fs-1 text-primary"
                        aria-hidden="true"
                      ></i>
                    </div>
                    <p class="fw-medium text-dark mb-1">Belum ada pesan</p>
                    <p
                      class="text-muted small mb-0"
                      v-if="level_name != 'ADMINISTRATOR' && status != 'closed'"
                    >
                      Tulis pesan pertama di bawah untuk memulai percakapan.
                    </p>
                    <p
                      class="text-muted small mb-0"
                      v-else-if="status == 'closed'"
                    >
                      Riwayat kosong atau belum dimuat.
                    </p>
                    <p class="text-muted small mb-0" v-else>
                      Riwayat percakapan akan tampil di sini.
                    </p>
                  </div>
                  <ul
                    v-else
                    class="list-unstyled chat-conversation-list msg-thread"
                    id="users-conversation"
                  >
                    <template
                      v-for="message in state.messages"
                      :key="message.id"
                    >
                      <li
                        v-if="message.username == namaLocalStorage"
                        class="chat-list right msg-row msg-row--own"
                      >
                        <div class="conversation-list">
                          <div class="user-chat-content">
                            <div class="ctext-wrap">
                              <div
                                class="ctext-wrap-content msg-bubble msg-bubble--own"
                              >
                                <div
                                  class="msg-meta d-flex flex-wrap align-items-baseline gap-2 mb-1"
                                >
                                  <span class="msg-author fw-semibold">{{
                                    message.username
                                  }}</span>
                                  <time class="msg-date small text-white-50">{{
                                    getDate(message.date)
                                  }}</time>
                                </div>
                                <p
                                  class="mb-0 ctext-content msg-text text-white"
                                >
                                  {{ message.content }}
                                </p>
                              </div>
                            </div>
                            <div class="conversation-name msg-foot-own">
                              <small class="text-muted time">{{
                                getTime(message.date)
                              }}</small>
                              <span
                                class="text-white-50 check-message-icon ms-1"
                                title="Terkirim"
                              >
                                <i
                                  class="ri-check-double-line align-bottom"
                                  aria-hidden="true"
                                ></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li v-else class="chat-list left msg-row msg-row--other">
                        <div class="conversation-list">
                          <div class="user-chat-content">
                            <div class="ctext-wrap">
                              <div
                                class="ctext-wrap-content msg-bubble msg-bubble--other"
                              >
                                <div
                                  class="msg-meta d-flex flex-wrap align-items-baseline gap-2 mb-1"
                                >
                                  <span
                                    class="msg-author fw-semibold text-primary"
                                    >{{ message.username }}</span
                                  >
                                  <time class="msg-date small text-muted">{{
                                    getDate(message.date)
                                  }}</time>
                                </div>
                                <p
                                  class="mb-0 ctext-content msg-text text-dark"
                                >
                                  {{ message.content }}
                                </p>
                                <div class="d-flex justify-content-end mt-2">
                                  <small class="text-muted time mb-0">{{
                                    getTime(message.date)
                                  }}</small>
                                </div>
                              </div>
                            </div>
                            <div class="conversation-name">
                              <span
                                class="text-success check-message-icon"
                                aria-hidden="true"
                              >
                                <i
                                  class="ri-check-double-line align-bottom"
                                ></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>

              <div
                class="chat-input-section p-3 p-lg-3 border-top bg-light bg-opacity-50 flex-shrink-0"
                v-show="level_name != 'ADMINISTRATOR'"
              >
                <form
                  @submit.prevent="SendMessage"
                  enctype="multipart/form-data"
                >
                  <p
                    v-if="status == 'closed'"
                    class="small text-danger mb-2 mb-lg-2"
                  >
                    <i class="ri-information-line me-1" aria-hidden="true"></i>
                    Tiket sudah ditutup. Anda tidak dapat mengirim pesan baru.
                  </p>
                  <div class="row g-2 align-items-stretch">
                    <div class="col">
                      <label class="visually-hidden" for="msg-input-field"
                        >Isi pesan</label
                      >
                      <input
                        id="msg-input-field"
                        type="text"
                        class="form-control form-control-lg rounded-3 border-0 shadow-sm msg-input"
                        v-model="inputMessage"
                        :placeholder="
                          status == 'closed'
                            ? 'Chat dinonaktifkan'
                            : 'Tulis pesan…'
                        "
                        autocomplete="off"
                        :disabled="status == 'closed'"
                        :aria-invalid="showInputError ? 'true' : 'false'"
                        @input="showInputError = false"
                      />
                      <div
                        class="invalid-feedback d-block small mt-1"
                        v-if="showInputError"
                        role="alert"
                      >
                        Masukkan pesan terlebih dahulu.
                      </div>
                    </div>
                    <div class="col-auto d-flex align-items-stretch">
                      <button
                        type="submit"
                        class="btn btn-primary btn-lg rounded-3 px-4 msg-send-btn"
                        :disabled="status == 'closed'"
                        :aria-label="'Kirim pesan'"
                      >
                        <i class="ri-send-plane-2-fill" aria-hidden="true"></i>
                        <span class="d-none d-sm-inline ms-1">Kirim</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderVue from "@/components/Header.vue";
import ProgressTiket from "@/components/ProgressTiket.vue";
import { db, storage } from "@/db";
import axios from "axios";
export default {
  components: {
    ProgressTiket,
    HeaderVue,
  },
  data() {
    return {
      inputMessage: null,
      namaLocalStorage: localStorage.getItem("nama"),
      keyLocalStorage: localStorage.getItem("email"),
      autono: window.atob(this.$route.query.q),
      status: window.atob(this.$route.query.status),
      db_url: null,
      state: {
        username: "",
        messages: [],
      },
      showChat: false,
      falseChat: "user-chat w-100 overflow-hidden",
      level_name: localStorage.getItem("level_name"),
      showInputError: false,
    };
  },
  methods: {
    SendMessage() {
      const messagesRef = db.database().ref(this.db_url);
      if (this.inputMessage === "" || this.inputMessage === null) {
        this.showInputError = true;
        return;
      }
      this.showInputError = false;
      const message = {
        username: localStorage.getItem("nama"),
        content: this.inputMessage,
        date: Date(),
      };
      messagesRef.push(message);
      this.inputMessage = "";

      try {
        axios
          .post("https://api.vitech.asia/api/setStatus", {
            tiket: localStorage.getItem("tiket"),
          })
          .then((res) => {
            // console.log(res);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },
    getTime(date) {
      if (date != null) {
        const splited = new Date(date).toLocaleTimeString("default", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return splited;
      }
    },
    getDate(date) {
      if (date != null) {
        const splited = new Date(date).toLocaleDateString("id-ID");
        return splited;
      }
    },
    updateClass(newClass) {
      this.showChat = newClass;
    },
    removeClass() {
      this.showChat = false;
    },
  },
  mounted() {
    // console.log(this.autono);
    // const new_aut = this.keyLocalStorage + "vta937iV99cqUgf" + this.autono;
    const emailNormalized = this.keyLocalStorage.trim().toLowerCase();
    const new_aut = emailNormalized + "vta937iV99cqUgf" + this.autono;
    // const db_url = window.btoa(new_aut).replace(/=+$/, "");
    const db_url = window
      .btoa(new_aut)
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
    this.db_url = db_url;
    if (this.status !== "closed") {
      const messagesRef = db.database().ref(db_url);
      messagesRef.on("value", (snapshot) => {
        const data = snapshot.val();
        let messages = [];
        if (data != null) {
          Object.keys(data).forEach((key) => {
            messages.push({
              id: key,
              username: data[key].username,
              content: data[key].content,
              date: data[key].date,
            });
          });
          this.state.messages = messages;
        }
      });
    } else {
      // console.log(this.autono);
      try {
        axios
          .post("https://api.vitech.asia/api/chatdb", {
            id: this.autono,
          })
          .then((res) => {
            // console.log(res.data.data);
            const data = res.data.data;
            let messages = [];
            Object.keys(data).forEach((key) => {
              messages.push({
                id: key,
                username: data[key].username,
                content: data[key].content,
                date: data[key].created_on,
              });
            });
            this.state.messages = messages;
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    }
  },
};
</script>
<style scoped>
.msg-page {
  min-height: calc(100vh - 7rem);
}

.msg-chat-shell {
  min-height: 420px;
}

.msg-min-h-0 {
  min-height: 0;
}

.msg-min-w-0 {
  min-width: 0;
}

.msg-topbar {
  background: linear-gradient(180deg, rgba(248, 249, 250, 0.95) 0%, #fff 100%);
}

.msg-back-btn {
  width: 2.25rem;
  height: 2.25rem;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.msg-conversation {
  min-height: 200px;
  max-height: calc(100vh - 16rem);
  overflow-y: auto;
}

.msg-empty-icon {
  width: 4.5rem;
  height: 4.5rem;
  background: rgba(64, 81, 137, 0.08);
}

.msg-bubble {
  border-radius: 0.75rem;
  padding: 0.65rem 0.85rem;
  box-shadow: 0 0.08rem 0.35rem rgba(15, 34, 58, 0.06);
}

.msg-bubble--own {
  background: linear-gradient(135deg, #405189 0%, #5568aa 100%);
  color: #fff;
}

.msg-bubble--other {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.msg-bubble--own .msg-author {
  color: rgba(255, 255, 255, 0.95);
}

.msg-text {
  line-height: 1.5;
  word-break: break-word;
}

.msg-foot-own {
  padding-right: 0.25rem;
}

.msg-send-btn {
  min-width: 3rem;
}

.msg-input:focus {
  box-shadow: 0 0 0 0.2rem rgba(64, 81, 137, 0.15);
}

.msg-closed-badge {
  font-weight: 500;
  white-space: normal;
  text-align: left;
  line-height: 1.35;
}

@media (max-width: 991.98px) {
  .msg-conversation {
    max-height: calc(100vh - 14rem);
  }
}
</style>
<!-- <script>
import { reactive, onMounted, ref } from "vue";
import ProgressTiket from "@/components/ProgressTiket.vue";
import db from "@/db";
import { useRoute } from "vue-router";
export default {
  components: {
    ProgressTiket,
  },
  setup() {
    const inputMessage = ref("");

    const namaLocalStorage = localStorage.getItem("nama");
    const keyLocalStorage = atob(sessionStorage.getItem("key"));
    const route = useRoute();
    const autono = window.atob(route.query.q);
    const status = window.atob(route.query.status);
    const new_aut = window.btoa(autono + "vta937iV99cqUgf").replace(/=+$/, "");

    const db_url = window.btoa(keyLocalStorage + new_aut).replace(/=+$/, "");

    const state = reactive({
      username: "",
      messages: [],
    });

    const SendMessage = () => {
      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;
      const messagesRef = db.database().ref(db_url);
      if (inputMessage.value === "" || inputMessage.value === null) {
        return;
      }
      const message = {
        username: localStorage.getItem("nama"),
        content: inputMessage.value,
        date: dateTime,
      };
      messagesRef.push(message);
      inputMessage.value = "";
    };

    const deleteField = (id) => {
      const dbRef = db.database().ref(db_url + "/" + id);
      dbRef.remove();
    };

    onMounted(() => {
      console.log(autono);
      const messagesRef = db.database().ref(db_url);
      messagesRef.on("value", (snapshot) => {
        const data = snapshot.val();
        let messages = [];
        Object.keys(data).forEach((key) => {
          messages.push({
            id: key,
            username: data[key].username,
            content: data[key].content,
            date: data[key].date,
          });
        });
        state.messages = messages;
      });
    });

    return {
      state,
      inputMessage,
      SendMessage,
      namaLocalStorage,
      deleteField,
      autono,
      status,
    };
  },
};
</script> -->
